//
import WhOrdererModel from "@/models/Warehouse/WhOrderer"

/**
 * List of wh orderer tos.
 *
 * @class      WhOrdererToList (name)
 */
export default class WhOrdererToList extends WhOrdererModel {

    /**
     * { item_description }
     */
    static includes = [
        "g_supervisor_user.hr_employee",
        "pch_provider",
        "pch_provider_branch_offices",
        //"wh_detail_orderers.wh_product",
        //"wh_detail_orderers.wh_warehouse",
        "wh_orderer_priority",
        "wh_warehouse",
    ]
}